const getComponentData = (state) => {
  const { skincarePermissions,accounts,fetching,permissionFeched ,error} = state.entries;
  
  const glowPermissions = skincarePermissions?.find(
    (skincarePermission) => skincarePermission.permissionAreaId === 1
  );
  const view =
    glowPermissions?.permissionLevelId === 2 ||
    glowPermissions?.permissionLevelId === 3 ||
    glowPermissions?.permissionLevelId === 4;
  const edit = glowPermissions?.permissionLevelId === 3 || glowPermissions?.permissionLevelId === 4;

  return {
    view,
    edit,
    accounts,
    permissionFeched,
    error,
    fetching
  };
};

export default getComponentData;
